import React, { useMemo, useState } from 'react'
import './SalesAlert.scss'
import { ReactComponent as CloseIcon } from '../../components/assets/images/CloseWhiteIcon.svg'
import { ReactComponent as TPOLogoNew } from '../../components/assets/images/WhiteLogo.svg'
import { mainApi } from '../../../store/services/mainApi'
import { useParams } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { setAllItemsCart, setItemsCart } from '../../../store/slices/allItemsCart'

const SalesAlert = () => {
  const { data: sales, isLoading, isError } = mainApi.useGetSalesQuery()
  const [openSales, setOpenSales] = useState([]);
  const tradeName = location.pathname.replace('/category/', '').replace('/newOrder/', '')

  const allItemsCart = useSelector((state) => state.allItemsCart.allItemsCart);
  const dispatch = useDispatch()

  const currentSale = useMemo(() => {
    if (!isLoading) {
      const saleActive = sales?.filter((el) => el?.isActive)
      const modifiedSale = sales?.map((el) => ({...el, products: el?.products?.map((elem) => ({...elem, fromSalespage: true}))}))
      setOpenSales(saleActive?.map((el) => el?._id))
      console.log(saleActive)
      
      return modifiedSale
    }
  }, [sales, isLoading])

  

  return (
    currentSale?.length > 0 ? 
        currentSale?.map((el, index) => 
          {
            const isAlert = el?.type == 'Alert'
            const isHide = localStorage.getItem('hidePromos') ? JSON.parse(localStorage.getItem('hidePromos'))?.includes(el?._id) : false
            let hide = null
            
            return openSales?.includes(el?._id) && el?.excludedBusinesses?.includes(tradeName) && !isHide ?
              (isAlert ? <div
                className='SalesAlert'
                onClick={() => setOpenSales(openSales?.filter((id) => id !== el?._id))}
              >
                <div className='SalesAlert__modal' onClick={(e) => e.stopPropagation()}>
                  <div className='SalesAlert__modal__header'>
                    <div className='SalesAlert__modal__header__label'>
                      <TPOLogoNew height={'31px'}/>
                      Tu Producto Online
                    </div>
                    <CloseIcon width={'15px'} height={'15px'} onClick={async () => {
                      setOpenSales(openSales?.filter((id) => id !== el?._id))
                    }}/>
                  </div>
                  <div className='wrapper'>
                    <div className='SalesAlert__modal__preview'>
                      <img src={el?.imgLink} alt={el?.img} />
                      <div className='SalesAlert__modal__info'>
                        <h1>{el?.name}</h1>
                        <p>{el?.description}</p>
                      </div>
                    </div>
                    
                    <div dangerouslySetInnerHTML={{ __html: el?.text }} className='SalesAlert__modal__text'>
                    </div>
                  </div>
                </div>
              </div>
              :
              <div
                className='SalesAlert'
                onClick={() => {
                  setOpenSales(openSales?.filter((id) => id !== el?._id))
                  if (hide) {
                    const hideData = JSON.parse(localStorage.getItem('hidePromo')) || []
                    localStorage.setItem('hidePromos', JSON.stringify([...hideData, el?._id]))
                  }
                }}
              >
                <div className='SalesAlert__modal' onClick={(e) => e.stopPropagation()}>
                  <div className='SalesAlert__modal__header'>
                    <div className='SalesAlert__modal__header__label'>
                      <TPOLogoNew height={'31px'}/>
                      Tu Producto Online
                    </div>
                    <CloseIcon width={'15px'} height={'15px'} onClick={async () => {
                      setOpenSales(openSales?.filter((id) => id !== el?._id))
                      if (hide) {
                        const hideData = JSON.parse(localStorage.getItem('hidePromo')) || []
                        localStorage.setItem('hidePromos', JSON.stringify([...hideData, el?._id]))
                      }
                    }}/>
                  </div>
                  <div className='wrapper'>
                    <div className='SalesAlert__modal__preview'>
                      <img src={el?.imgLink} alt={el?.img} />
                      <div className='SalesAlert__modal__info'>
                        <h1>{el?.name}</h1>
                        <p>{el?.description}</p>
                      </div>
                    </div>
                    <div className='SalesAlert__modal__list'>
                      {el?.products?.length > 0 && 
                      el?.products?.map((sale, index) => {
                        const inCart = allItemsCart.find((elem) => elem?.sku == sale.sku);
                        return <div
                          key={index}
                          className='SalesAlert__modal__list__item'
                        >
                          <div className="img">
                            <img src={sale?.img} alt="" />
                          </div>
                          <div className="column">
                            <p>
                              {sale?.name ? sale.name : 'Name not found'}
                            </p>
                            <div className='SalesAlert__modal__list__item__price'>
                              {sale?.spoPrice == sale?.marketPriceCP || !sale?.spoPrice ?
                              <h1>€{sale?.marketPriceCP}</h1>
                              : <><h2>€{sale?.marketPriceCP}</h2>
                              <h1 style={{ color: '#E7000B'}}>€{sale?.spoPrice}</h1>
                              </>}
                            </div>
                          </div>
                          <button
                            onClick={() => {
                              dispatch(setAllItemsCart({...sale, quantity: 1}))
                            }}
                            style={inCart ? {
                              background: '#fff',
                              color: '#3bb77e',
                              border: '2px solid #3bb77e'
                            } : {}}
                          >
                            {inCart ? <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.3335 17.833C8.11575 17.8332 8.74951 18.4677 8.74951 19.25C8.74934 20.0321 8.11564 20.6658 7.3335 20.666C6.5512 20.666 5.91668 20.0323 5.9165 19.25C5.9165 18.4676 6.55109 17.833 7.3335 17.833Z" stroke="#3bb77e" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M17.417 17.833C18.1992 17.8332 18.833 18.4677 18.833 19.25C18.8328 20.0321 18.1991 20.6658 17.417 20.666C16.6347 20.666 16.0002 20.0323 16 19.25C16 18.4676 16.6346 17.833 17.417 17.833Z" stroke="#3bb77e" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M1.87939 1.87891H3.71273L6.15106 13.2639C6.24051 13.6809 6.47251 14.0536 6.80713 14.3179C7.14175 14.5823 7.55806 14.7217 7.98439 14.7122H16.9494C17.3666 14.7116 17.7712 14.5686 18.0962 14.3069C18.4212 14.0453 18.6472 13.6806 18.7369 13.2731L20.2494 6.46224H4.69356" stroke="#3bb77e" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg> : <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7.3335 17.833C8.11575 17.8332 8.74951 18.4677 8.74951 19.25C8.74934 20.0321 8.11564 20.6658 7.3335 20.666C6.5512 20.666 5.91668 20.0323 5.9165 19.25C5.9165 18.4676 6.55109 17.833 7.3335 17.833Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M17.417 17.833C18.1992 17.8332 18.833 18.4677 18.833 19.25C18.8328 20.0321 18.1991 20.6658 17.417 20.666C16.6347 20.666 16.0002 20.0323 16 19.25C16 18.4676 16.6346 17.833 17.417 17.833Z" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M1.87939 1.87891H3.71273L6.15106 13.2639C6.24051 13.6809 6.47251 14.0536 6.80713 14.3179C7.14175 14.5823 7.55806 14.7217 7.98439 14.7122H16.9494C17.3666 14.7116 17.7712 14.5686 18.0962 14.3069C18.4212 14.0453 18.6472 13.6806 18.7369 13.2731L20.2494 6.46224H4.69356" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>}
                            
                          </button>
                        </div>}
                      )}
                    </div>
                    <div className='SalesAlert__modal__all'>
                      <div className='SalesAlert__modal__all__hide'>
                        <input 
                          type="checkbox" 
                          checked={hide}  
                          onChange={() => {
                            if (!hide) {
                              hide = el?._id
                            } else {
                              hide = null
                            }
                          }}
                        />
                        No quiero ver más promo
                      </div>
                      <button>
                        View All Products
                      </button>
                    </div>
                  </div>
                </div>
              </div>)
            : null
          }

      ) 
    : null)
}

export default SalesAlert